import axios from 'axios';
import Constant from '../lib/constant';
import userApi from './user';

const axiosClient = axios.create({
	baseURL: Constant.apiUrl,
	headers: {
		'X-API-Key': Constant.apiKey,
		Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
	},
});

axiosClient.interceptors.request.use(
	async (config) => {
		const accessToken = localStorage.getItem('accessToken');
		if (accessToken) {
			config.headers['Authorization'] = 'Bearer ' + accessToken;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

axiosClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response) {
      if (error.response.status === 403 && !originalRequest._retry) {
        originalRequest._retry = true;
        try {
          const refreshToken = localStorage.getItem('refreshToken');
          if (refreshToken) {
            console.log({ refreshToken });
            const res = await userApi.refreshToken({ refreshToken });
            if (res.status === 200) {
              const { accessToken } = res.data;
              localStorage.setItem('accessToken', accessToken);

              originalRequest.headers['Authorization'] = 'Bearer ' + accessToken;
              return axiosClient(originalRequest);
            }
          }
        } catch (refreshError) {
          localStorage.removeItem('accessToken');
          window.location.href = '/login';
          return Promise.reject(refreshError);
        }
      }
    } else {
      // Xử lý lỗi nếu error.response không có
      console.error('No response received:', error);
    }

    return Promise.reject(error);
  }
);

export default axiosClient;
